import { createSlice } from '@reduxjs/toolkit';

type initailStateType = {
  transactionTypesList: { title: string; id: number }[] | undefined;
};

const initialState: initailStateType = { transactionTypesList: undefined };

const financialReducer = createSlice({
  name: 'financial',
  initialState,
  reducers: {
    setTransactionTypesList: (state, action) => {
      state.transactionTypesList = action.payload;
    },
  },
});

export const { setTransactionTypesList } = financialReducer.actions;
export default financialReducer.reducer;
